export default __webpack_public_path__ + "static/media/Flag_of_Romania.3daa4cc2.svg";